import { useState } from "react"
import { useAsyncInterval } from "../../hooks/useInterval"
import { IRecord } from "../../types/schema"
import { useAsyncEffect } from "../../hooks/useAsyncEffect"

export function useSiteBanner() {
  const skeem = window.skeem

  const [banner, setBanner] = useState<string | null>(null)

  async function loadRecent() {
    const banner = await skeem.fetch2<IRecord<"globalSettings", "siteBannerMessage">>({
      first: {
        name: "globalSettings",
        attributes: ["siteBannerMessage"],
      },
    })
    setBanner(banner?.siteBannerMessage || null)
  }

  useAsyncEffect(loadRecent, [])
  useAsyncInterval(loadRecent, 1000 * 60)

  return banner
}
